import React, { PureComponent } from 'react';
import { Trans, } from '@lingui/macro';

import { getPinColor, stringifyPinId } from '../utils/trip';
import { gaEvent, mixpanelTrack } from '../utils/track';

class SystemHotStation extends PureComponent {
    constructor(props) {
        super(props);
        const keysSorted = Object.keys(props.data.borrow)
            .sort((a, b) => props.data.borrow[a] - props.data.borrow[b])
            .reverse();
        let flag = 1;
        const showNum = 10;
        const topStation = [];
        for (const id in keysSorted) {
            if (keysSorted[id]) topStation.push(keysSorted[id]);
            if (flag === showNum) break;
            flag += 1;
        }
        this.state = {
            topStation,
        };
    }

    genContent = () => {
        const {
            data, geo,
        } = this.props;
        const { topStation } = this.state;
        const tmpl = [];
        topStation.forEach((id) => {
            const { station } = geo[id];
            tmpl.push(
                <tr key={id}>
                    <td>{station}</td>
                    <td>{data.borrow[id]}</td>
                    <td>
                        {/* <a
                            href={genLink(lang, `/${system}/od/${id}?ref=system-expose`)}
                            target="_blank"
                            onClick={() => {
                                gaEvent('System', 'Expose View Station OD', id);
                            }}
                        >
                            <i className="fa fa-external-link" />
                        </a> */}
                    </td>
                </tr>,
            );
        });

        return tmpl;
    }

    handleTopTenTrip = (pinId) => {
        const { addPinIds } = this.props;
        addPinIds(pinId);
        gaEvent('System', 'View Top 10 trip');
        mixpanelTrack({ category: 'Trip', ref: 'System View Top 10 trip' });
    }

    render() {
        const { topStation } = this.state;
        const pinId = {};
        topStation.forEach((id, index) => {
            pinId[id] = getPinColor(index);
        });
        return (
            <>
                <h3 className="system-head"><Trans id="system.hotStation" /></h3>
                <div className="row mb-3">
                    <div className="col-md-12 col-xs-12">
                        <table className="table top-10-table">
                            <thead>
                                <tr>
                                    <th><Trans id="system.hotStation" /></th>
                                    <th><Trans id="system.dealNumber" /></th>
                                    <th />
                                </tr>
                            </thead>
                            <tbody>{this.genContent()}</tbody>
                        </table>
                        <div className="left">
                            {/* <Link
                          to={{
                              pathname: genLink(lang, `/${system}/trip`),
                              search: `?${stringifyPinId(pinId)}`,
                          }}
                          className="btn btn-default btn-xs"
                          onClick={() => this.handleTopTenTrip(pinId)}
                      >
                          {t('system.viewTop10Trips')}
                      </Link> */}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default SystemHotStation;
